@if (vendor) {
  <div class="flex-fill d-flex flex-column">
    <div class="btn-toolbar mx-3 mb-0 mt-3">
      @if (hasChanges()) {
        <button type="button" (click)="save()" class="btn btn-primary me-2">Save</button>
      }
      @if (hasChanges()) {
        <button type="button" (click)="cancel()" class="btn btn-success">Cancel</button>
      }
      @if (!hasChanges()) {
        <button type="button" (click)="close()" class="btn btn-primary">Close</button>
      }
    </div>
    <div class="grid-fill m-3">
      @if (vendor) {
        <dx-form [formData]="vendor" [colCount]="2">
          <dxi-item itemType="group">
            <dxi-item itemType="group" caption="Vendor Information">
              <dxi-item dataField="companyName" [label]="{ text: 'Company' }" [isRequired]="true"></dxi-item>
              <dxi-item dataField="contactName" [label]="{ text: 'Contact' }"></dxi-item>
              <dxi-item dataField="email" [label]="{ text: 'Email' }"> </dxi-item>
              <dxi-item itemType="group" [colCount]="2">
                <dxi-item dataField="phone" [label]="{ text: 'Phone' }"></dxi-item>
                <dxi-item dataField="fax" [label]="{ text: 'Fax' }"></dxi-item>
              </dxi-item>
              <dxi-item itemType="group" [colCount]="2">
                <dxi-item dataField="accountNumber" [label]="{ text: 'Account #' }"></dxi-item>
                <dxi-item dataField="terms" [label]="{ text: 'Terms' }" [editorOptions]="{ disabled: true }"></dxi-item>
              </dxi-item>
              <dxi-item itemType="group" [colCount]="2">
                <dxi-item dataField="quickBooksId" [label]="{ text: 'QB Id' }" [editorOptions]="{ disabled: true }"></dxi-item>
                <dxi-item dataField="quickBooksLastExport" [label]="{ text: 'Last Export' }" [editorOptions]="{ disabled: true }"></dxi-item>
              </dxi-item>
            </dxi-item>
            <dxi-item itemType="group" caption="Notes">
              <dxi-item dataField="notes" [label]="{ text: 'Shipping Notes' }" editorType="dxTextArea" [editorOptions]="{ height: '150px' }"></dxi-item>
              <dxi-item dataField="internalNotes" [label]="{ text: 'Internal Notes' }" editorType="dxTextArea" [editorOptions]="{ height: '150px' }"></dxi-item>
            </dxi-item>
          </dxi-item>
          <dxi-item itemType="group">
            <dxi-item itemType="group" caption="Remit Address">
              <dxi-item dataField="remitAddress1" [label]="{ text: 'Address 1' }"></dxi-item>
              <dxi-item dataField="remitAddress2" [label]="{ text: 'Address 2' }"></dxi-item>
              <dxi-item itemType="group" [colCount]="3">
                <dxi-item dataField="remitCity" [label]="{ text: 'City' }" [colSpan]="2"></dxi-item>
              </dxi-item>
              <dxi-item itemType="group" [colCount]="3">
                <dxi-item
                  dataField="remitState"
                  [label]="{ text: 'State' }"
                  editorType="dxSelectBox"
                  [editorOptions]="{ items: states, showClearButton: false }"
                ></dxi-item>
                <dxi-item dataField="remitZip" [label]="{ text: 'Zip' }"></dxi-item>
              </dxi-item>
              <dxi-item dataField="remitEmail" [label]="{ text: 'Remit Email' }"> </dxi-item>
              <dxi-item itemType="group" [colCount]="2">
                <dxi-item dataField="remitPhone" [label]="{ text: 'Remit Phone' }"></dxi-item>
                <dxi-item dataField="remitFax" [label]="{ text: 'Remit Fax' }"></dxi-item>
              </dxi-item>
              <dxi-item
                dataField="terms"
                [label]="{ text: 'Terms' }"
                editorType="dxSelectBox"
                [editorOptions]="{ items: terms, valueExpr: 'name', displayExpr: 'name', showClearButton: false, width: '150px' }"
              ></dxi-item>
            </dxi-item>
            <dxi-item itemType="group" caption="Address">
              <dxi-item dataField="address1" [label]="{ text: 'Address 1' }"></dxi-item>
              <dxi-item dataField="address2" [label]="{ text: 'Address 2' }"></dxi-item>
              <dxi-item itemType="group" [colCount]="3">
                <dxi-item dataField="city" [label]="{ text: 'City' }" [colSpan]="2"></dxi-item>
              </dxi-item>
              <dxi-item itemType="group" [colCount]="3">
                <dxi-item dataField="state" [label]="{ text: 'State' }" [visible]="vendor.country === 'OTHER'"></dxi-item>
                <dxi-item
                  dataField="state"
                  [label]="{ text: 'State' }"
                  editorType="dxSelectBox"
                  [editorOptions]="{ items: states, showClearButton: false }"
                  [visible]="vendor.country !== 'OTHER'"
                ></dxi-item>
                <dxi-item dataField="zip" [label]="{ text: 'Zip' }"></dxi-item>
                <dxi-item
                  dataField="country"
                  [label]="{ text: 'Country' }"
                  editorType="dxSelectBox"
                  [editorOptions]="{ items: countries, showClearButton: false }"
                ></dxi-item>
              </dxi-item>
            </dxi-item>
          </dxi-item>
        </dx-form>
      }
    </div>
  </div>
}
